<template>
  <div>
    <div class="page-title">已绑定银行卡信息</div>
    <page-search
      :layout="['customName', 't_agent_info_agent_name']"
      @search="search"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageIndex="page"
      :pageSize="pageSize"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>

<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import { getBindingCard } from '@/api/settleAccounts'
import { addQuery, formatTitle } from '@/utils/common'
export default {
  name: 'accounts',
  components: {
    pageSearch,
    pageTable
  },
  mixins: [pageTableMixin],
  data() {
    return {
      col: [
        { field: 'infoNo', title: '序号', width: 50, titleAlign: 'left', columnAlign: 'left' },
        { field: 'cust_no', title: '客户编码', width: 110, titleAlign: 'left', columnAlign: 'left' },
        { field: 't_agent_info_agent_name', title: '渠道', width: 160, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'custname', title: '客户名称', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'bankname', title: '行别', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'custname', title: '银行账户名称', width: 220, isResize: true, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'acctId', title: '账号', width: 180, titleAlign: 'left', columnAlign: 'left', formatter(rowData, index, pageIndex, field) {
          return formatTitle(rowData[field])
        } },
        { field: 'auth_time', title: '绑定时间', width: 150, titleAlign: 'left', columnAlign: 'left' }
      ],
      queryName: '', // 搜索的企业名称
      t_agent_info_agent_name: '' // 渠道
    }
  },
  methods: {
    initPage() {
      this.queryName = ''
      this.t_agent_info_agent_name = ''
    },
    // 获取表格
    getData() {
      let query = {
        per_page: this.pageSize,
        page: this.page
      }
      query = addQuery(query, 'custname', this.queryName)
      query = addQuery(query, 't_agent_info_agent_name', this.t_agent_info_agent_name)
      this.tableLoading = true
      getBindingCard(query).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          if (res.result === undefined || res.result === null || !Array.isArray(res.result.data)) {
            this.tableData = []
            this.total = 0
          } else {
            this.tableData = res.result.data.map((item, index) => {
              return {
                infoNo: res.result.from + index,
                cust_no: item.cust_no,
                t_agent_info_agent_name: item.t_agent_info_agent_name,
                custname: item.custname,
                bankname: item.bankname,
                acctId: item.acctId,
                auth_time: item.auth_time
              }
            })
            this.total = res.result.total
          }
        }
      })
    },
    // 搜索
    search(query) {
      this.queryName = query.customName || ''
      this.t_agent_info_agent_name = query.t_agent_info_agent_name || ''
      this.initTable()
      this.getData()
    }
  }
}
</script>

